<template>
  <div
    class="decorator-pic"
    ref="decoratorPic"
    :class="[isEmpty(position) ? '' : 'absolute-el']"
    :style="{
      '--hover-cursor': hoverStyle?.cursor || 'auto',
      ...position,
      ...customStyle,
    }"
  >
    <img v-if="source" :src="source" alt="" />
  </div>
</template>

<script setup lang="ts">
import { isEmpty } from "lodash-es"
import { ref } from "vue"

interface DecoratorPicProps {
  id: string
  position?: any
  source?: string
  customStyle?: any
  hoverStyle?: any
}

const decoratorPic = ref<HTMLDivElement | null>(null)
// console.log('decoratorPic 2', decoratorPic, import.meta.env.MODE );

withDefaults(defineProps<DecoratorPicProps>(), {})
</script>

<style lang="scss" scoped>
.decorator-pic {
  position: absolute;

  img {
    width: 100%;
    height: 100%;
  }
}

.decorator-pic:hover {
  cursor: var(--hover-cursor);
}
</style>
